import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {take} from "rxjs";
import {ErrorMessageEnum} from "../../../../../shared/enums/error-message.enum";
import {AccessService} from "../../../../../service/api/access.service";
import {MessageToastService} from "../../../../../service/message-toast.service";

@Component({
    selector: 'app-account-activation',
    templateUrl: './account-activation.component.html',
    standalone: false
})
export class AccountActivationComponent implements OnInit {

  step: 'request' | 'confirm' = 'request'
  form: FormGroup;
  formErrors: Map<string, string> = new Map();

  constructor(private accessService: AccessService,
              private messageToastService: MessageToastService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      "phoneNumber": new FormControl(null, [Validators.required, Validators.pattern(/^\d{9}$/)]),
      "pin": new FormControl(null),
    });

    this.route.queryParams.pipe(take(1)).subscribe(params => {
      if (params['fase'] === 'pin') {
        this.step = 'confirm'
      }
    })
  }

  showStep(step: 'request' | 'confirm') {
    this.step = step
    this.formErrors.clear()
  }

  onRequestPin() {
    this.formErrors.clear()
    if (!this.phoneIsValid()) return

    this.accessService.requestAccountActivation({phoneNumber: this.form.value.phoneNumber})
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.messageToastService.success(response.message)
          this.showStep('confirm')
        },
        error: (apiErrorResponse) => {
          this.formErrors = apiErrorResponse?.formErrors ?? new Map()
          this.messageToastService.error(apiErrorResponse?.message)
        }
      })
  }

  onConfirmPin() {
    this.formErrors.clear()
    if (!this.phoneIsValid() || !this.pinIsValid()) return

    this.accessService.activateAccount({
      phoneNumber: this.form.value.phoneNumber,
      pin: this.form.value.pin
    }).pipe(take(1)).subscribe({
      next: (response) => {
        this.router.navigate(["/acesso"]).then(() => this.messageToastService.success(response.message))
      },
      error: (apiErrorResponse) => {
        this.formErrors = apiErrorResponse?.formErrors ?? new Map()
        this.messageToastService.error(apiErrorResponse?.message)
      }
    })
  }

  private phoneIsValid(): boolean {
    const phone = this.form.get("phoneNumber")
    if (phone?.hasError("required")) {
      this.formErrors.set('phoneNumber', ErrorMessageEnum.requiredField)
      return false
    }
    if (phone?.hasError("pattern")) {
      this.formErrors.set('phoneNumber', ErrorMessageEnum.invalidPhone)
      return false
    }
    return true
  }

  private pinIsValid(): boolean {
    const pin = String(this.form.value.pin ?? '')
    if (!pin) {
      this.formErrors.set('pin', ErrorMessageEnum.requiredField)
      return false
    }
    if (!/^\d{5}$/.test(pin)) {
      this.formErrors.set('pin', ErrorMessageEnum.invalidPin)
      return false
    }
    return true
  }
}
